<template>
  <div class="TableWrapper">
    <slot />
  </div>
</template>

<script>
import './style.scss'

export default {
  name: 'TableWrapper',
}
</script>
